import { useEffect } from 'react';

// This hook relies on a Navattic embed script currently loaded in gatsby-ssr and managed in Navattic
// See more information in Navattic by choosing a demo and selecting share > popup > embed code
// https://js.navattic.com/embeds.js

declare global {
  interface Window {
    NavatticEmbed?: {
      initPopup?: (url: string, options: { title: string }) => void;
      openPopup?: (url: string) => void;
    };
  }
}

export default function useNavattic(
  action: Queries.LINKFragment['linkElements']['action']['value'] | undefined | null
) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!action?.__typename) return;
    if (action.__typename !== 'kontent_item_link_action_navattic_pop_up') return;
    if (!window.NavatticEmbed?.initPopup || !window.NavatticEmbed?.openPopup) return;
    window.NavatticEmbed.initPopup(action.elements.url.value, {
      title: action.elements.title.value,
    });

    const element = document.querySelector(`[data-navattic-open="${action.elements.url.value}"]`);
    if (!element) return;
    const handleClick = function () {
      window.NavatticEmbed!.openPopup!(action.elements.url.value);
    };
    element.addEventListener('click', handleClick);

    return () => {
      element.removeEventListener('click', handleClick);
    };
  }, [action]);
}
